import BsAccount from './index.vue'
export default BsAccount